import React, { useEffect, useState } from "react";
import { SafeAreaView, StyleSheet, useWindowDimensions, View } from "react-native";
import Modal from "react-native-modal";
import { useAuthContext } from "../../../hooks/useAuthContext";
import CustomButton from '../../CustomButton/CustomButton';
import CustomDropDownWithIcons from "../../CustomDropDownWithIcons/CustomDropDownWithIcons";
import CustomLabel from "../../CustomLabel/CustomLabel";
import { useTheme } from '@react-navigation/native';
import { useTranslation } from 'react-i18next';
import { useAssessment } from "../../../hooks/useAssessment";

const PopUpPart = ({toassmUi, setRefresh, wfl}) => {

    const { user, clientApi, username } = useAuthContext();
    const  {loadEveryAssessment, CopyAssmPart} = useAssessment(); 
    const { colors } = useTheme()
    const styles = makeStyles(colors);
    const { t } = useTranslation();
    const { width, height } = useWindowDimensions();
    const [PopUpvisible, setPopUpVisible] = useState(false);
    const [assmList, setAssmList] = useState([]);
    const [selected, setselected] = useState('');
    const { loadParticipants } = useAssessment();

    async function loadAndFilterAssessments() {
        try {
            const assm = await loadEveryAssessment(clientApi, user.token, username);
            const tempAssm = [];

            for (const assmItr of assm) {
            const participants = await loadParticipants(assmItr.assmUi);
            
            if (participants.length !== 0) {
                if (assmItr.assmType === wfl) {
                    tempAssm.push({ label: assmItr.description, value: assmItr.assmUi });
                    setAssmList([
                        ...tempAssm,
                        { label: t("common:loadingMoreAssm"), value: "loading" }
                    ]);
                }
            }
            }

            setAssmList(tempAssm);
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
       loadAndFilterAssessments();
    }, []);

    useEffect(
        () => { }, [width, height]
    );

    const showPopUp = (e) => {
        setPopUpVisible(!PopUpvisible)
    };

    const handleCopyPart = () => {
        CopyAssmPart(clientApi, user.token, username, selected, toassmUi)
        .then(resp => {
            showPopUp()
            setRefresh(1)
        }).catch(error => {
            console.log(error)
        });
    };

    return (
        <SafeAreaView  style={styles.main}>
            <View style={styles.rowBtn}>
                <CustomButton
                    text={t('common:importPart')}
                    onPress={() => { showPopUp() }}
                    iconName='download-outline'
                    show='SURVEY'
                    type='SURVEY'
                    textTop='0'
                    sz={25}
                />
            </View>

            <Modal
                isVisible={PopUpvisible}
                deviceWidth={width}
                deviceHeight={height}
                hasBackdrop={true}
                backdropColor={colors.background_approved}
                backdropOpacity={0.9}
                onBackdropPress={() => { showPopUp() }}
                onRequestClose={() => { showPopUp() }}
            >
                <SafeAreaView
                    style={styles.main}>
                    <CustomLabel
                        value={t('common:importPart')}
                        type='MINORTITLE'
                    />

                    <SafeAreaView
                        style={styles.dropDownView}>
                        <CustomDropDownWithIcons
                            defValue={selected}
                            options={assmList}
                            value={selected}
                            setValue={(e) => {setselected(e)}}
                            type='FULL'
                        />
                    </SafeAreaView>
                    <SafeAreaView
                        style={styles.buttons}>
                        <SafeAreaView
                            style={styles.row}>
                            <CustomButton
                                onPress={() => { showPopUp() }}
                                iconName='close-outline'
                                show='HOME_BELL'
                                type='HOME_BELL'
                                textTop='0'
                                sz={30}
                            />
                            <CustomButton
                                onPress={() => {handleCopyPart()}}
                                iconName='checkmark-outline'
                                show='HOME_BELL'
                                type='HOME_BELL'
                                textTop='0'
                                sz={30}
                            />
                        </SafeAreaView>
                    </SafeAreaView>
                </SafeAreaView>
            </Modal>
        </SafeAreaView>
    );
};

const makeStyles = (colors) => StyleSheet.create({
    main: {
        justifyContent: 'center',
    },
    dropDownView: {
        margin: 20,
    },
    buttons: {
        alignSelf: 'flex-end',

    },
    row: {
        alignItems: 'center',
        flexDirection: 'row',
    },
    rowBtn: {
        flexDirection: 'row',
        justifyContent: 'flex-start',
    },
});

export default PopUpPart;


